import React, {useState} from 'react';
import {ga4SendOnce} from "../../function";

const UseStateWithGa4 = ({init,event}) => {
    const [state,setState]  = useState(init)

    const onChangeState = (value) => {
        setState(value)
        ga4SendOnce(event)
    }

    return [state,onChangeState]
};

export default UseStateWithGa4;